import React, { Component,Fragment } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBTableBody,MDBTable, MDBTableHead, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import domtoimage from 'dom-to-image';
import { api, URL } from '../../api';

export default class Modaladdteachershow extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,
  emp:[],
  teacherCurriculum:[],
  Teacher_Citizen_ID:'',
  Curriculumopen_ID:'',
  Curriculumopen_Full_Name_TH:'',
  Univ_ID:'',
  Univ_NAME:'',
  Curriculumopen_Approve_Cu:'',
}

//this.handleChange = this.handleChange.bind(this);
this.handleChangeName_EN = this.handleChangeName_EN.bind(this);
this.handleChangeName_TH = this.handleChangeName_TH.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangeteam = this.handleChangeteam.bind(this);
this.handleChangeCH = this.handleChangeCH.bind(this);
this.handleChangeTIMESTART = this.handleChangeTIMESTART.bind(this);
this.handleChangeEND = this.handleChangeEND.bind(this);

this.onChange = this.onChange.bind(this);
this.onFocus = this.onFocus.bind(this);
this.onBlur = this.onBlur.bind(this);
this.onSearch = this.onSearch.bind(this);

this.getteacherforcurriculum = this.getteacherforcurriculum.bind(this);
this.onChangedelectid = this.onChangedelectid.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal,
    Curriculumopen_ID:this.props.Curriculumopen_ID,
    Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH,
    Univ_ID:this.props.Univ_ID
  });
 // this.props.getclassroom();
 this.getteacherforcurriculum();
}


   onBlur() {
    console.log('blur');
  }
  
   onFocus() {
    console.log('focus');
  }
  
   onSearch(val) {
    console.log('search:', val);
  }


//handleChange2(event) {    this.setState({send_comment1: event.target.value});  }
getteacherforcurriculum() {
    setTimeout(() => {
       //ภายใน
        Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getteacherforcurriculum/'+this.props.Curriculumopen_ID)
       .then(res => {
        // console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ teacherCurriculum: res.data})
       }) 
     }, 0);
}

 componentDidMount() {

  //const { id_send } = this.props.id_send

  //console.log(this.props.Curriculumopen_ID);
  this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID})
  this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
  this.setState({ Univ_ID:this.props.Univ_ID})
  this.setState({ Univ_NAME:localStorage.getItem('Univ_NAME')})
  this.setState({ Curriculumopen_Approve_Cu:this.props.Curriculumopen_Approve_Cu})
  
  //this.setState({ Curriculumopen_User_UPDATE:localStorage.getItem('type2')})

  Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/'+localStorage.getItem('Univ_ID'),
  //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
    //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
            {headers: {
            // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }
            })
            //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
            .then(res => {
            // console.log(res.data[0].id)
            //  console.log(res.data)
          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
            //  console.log(Course)
               const emp = res.data;
                this.setState({ emp });
     }) 
 this.getteacherforcurriculum();
  }

  onChange(value) {
    //  console.log(`selected ${value}`);
    this.setState({ Teacher_Citizen_ID:value})

     //  const idemp = value;
     //  this.setState({ idemp });
    }



  handleChangeteam(event) {    this.setState({Curriculumopen_TEAM: event.target.value});  }
  handleChangeName_TH(event) {    this.setState({Curriculumopen_Full_Name_TH: event.target.value});  }
  handleChangeName_EN(event) {    this.setState({Curriculumopen_Full_Name_EN: event.target.value});  }
  handleChangeCH(event) {    this.setState({Curriculumopen_CH: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
  handleChangeTIMESTART(event) {    this.setState({Curriculumopen_Date_START: event.target.value});  }
  handleChangeEND(event) {    this.setState({Curriculumopen_Date_END: event.target.value});  }




  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("Teacher_Citizen_ID", this.state.Teacher_Citizen_ID);
      datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
      datafrm.append("Univ_ID", this.state.Univ_ID);
      
   Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddTeacherforcurriculum/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'บันทึกข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                    
                    })
                 }
        })
        this.getteacherforcurriculum();
       // this.toggle()
      //  this.props.getclassroom()

}, 2000);

//window.location.href = '/Curriculum'
//this.props.updateat();
//this.getExpert()
 
  }



          onChangedelectid(event) {

            //  console.log(`switch to ${checked}`);
              console.log(`switch to ${event.target.value}`);
             const id = event.target.value;

              Swal.fire({
                        title: 'ยืนยันการลบข้อมูล',
                        icon: 'warning',
                       // text: 'กรุณาลองอีกครั้ง',
                      // showCancelButton: true,
                        confirmButtonText: 'ตกลง',
                     //  cancelButtonText: 'No, keep it'
                      }).then((result) => {
                        console.log(`switch to 888`);

                                      setTimeout(() => {
          
                                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                        datafrm.append("Curriculumopen_ID", this.state.Curriculumopen_ID);
                                        datafrm.append("Teacher_Citizen_ID", id);
                                        api.post("index/deleteteacherculiculum/",datafrm,{
                                          headers: {
                                              'content-type': 'multipart/form-data'
                                          }
                                        })
                                  
                                        .then(res => {
                                      //    console.log(res);
                                          if (res.status === 200) {
                                          //  alert("บันทึกสำเร็จ")
                                                    Swal.fire({
                                                        title: 'ลบข้อมูลสำเร็จ',
                                                        icon: 'success',
                                                      // showCancelButton: true,
                                                        confirmButtonText: 'ตกลง',
                                                      // cancelButtonText: 'No, keep it'
                                                      }).then((result) => {
                                                      
                                                      })
                                                  }
                                          })
                                        //  this.toggle()
                                        //  this.props.getclassroom()
                                      //  this.getCurriculumopen();
                                      this.getteacherforcurriculum()
                                  }, 1000);



                      })
                    }








    render() {
       //    console.log(this.state.Curriculumopen_ID)
      //   console.log(this.state.Curriculumopen_Approve_Cu)
       //  console.log(this.state.Univ_ID)
       // console.log(this.state.Curriculumopen_CH)
       // console.log(this.state.Curriculumopen_Date_START)
       // console.log(this.state.Curriculumopen_Date_END)
        const { Option } = Select;







      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
        
        return (
            <>
            {/* <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">รายชื่อยังไม่ได้ฉีดวัคซีน</MDBBtn> */}
            <MDBBtn onClick={this.toggle}  color="dark-green" size="sm"> แสดงข้อมูลผู้สอน</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader  toggle={this.toggle}><MDBIcon icon="plus-square" /> แสดงข้อมูลผู้สอน</MDBModalHeader>
              <MDBModalBody>
               
              <br/>
              <div id="pdfdiv">
              
            
      
                 <div className="form-group">
                    <label htmlFor="example2">ชื่อหลักสูตรภาษาไทย</label>
                    <input type="text" id="example2" className="form-control form-control-md" value={this.state.Curriculumopen_Full_Name_TH} disabled  />
                </div>
              
                {/* <div className="form-group">
                    <label htmlFor="example2">ค้นหาอาจารย์ผู้สอน</label>
                    <div>
                        <Select
                        showSearch
                        style={{ width: 300 }}
                        placeholder="เลือกอาจารย์"
                        optionFilterProp="children"
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        onSearch={this.onSearch}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                    {this.state.emp.map((emp,index )  => 
                    <option value={emp.Teacher_Citizen_ID}>{emp.Teacher_NAME +" "+ emp.Teacher_LASTNAME}</option>
                    )}
                    </Select>
                    <MDBBtn color="dark-green" size="sm" onClick={this.handleSubmit}>เพิ่มอาจารย์</MDBBtn>
                    </div>
                </div> */}
                <br/>
               

                <p className="display-5 deep-purple-text">อาจารย์ผู้สอนประจำหลักสูตร</p>          
                <MDBTable small>
                    <MDBTableHead color="grey darken-1" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ - นามสกุล</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                    {this.state.teacherCurriculum.map((teacherCurriculum,index) => {
                     return   <tr>
                              <td>{index+1}</td>
                              <td>{teacherCurriculum.Teacher_PNAME}{teacherCurriculum.Teacher_NAME}  {teacherCurriculum.Teacher_LASTNAME}</td>
                              <td>
                                {this.state.Curriculumopen_Approve_Cu === '2' ?<>
                                {/* <p className="orange-text"> ไม่สามารถลบได้เนื่องจากอนุมัติแล้ว</p> */}
                                 <MDBBtn color="unique" size="sm" disabled  >ลบ</MDBBtn>
                                </>:<>
                                <MDBBtn color="unique" size="sm" value={teacherCurriculum.Teacher_Citizen_ID} onClick={this.onChangedelectid}  >ลบ</MDBBtn>
                                </>}
                                
                                </td>
                              </tr>
                    })}  
                       
                    </MDBTableBody>
                </MDBTable>
               
            
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
